import { SxProps, Theme } from "@mui/material";

export const tabsSx: SxProps<Theme> = {
  mb: 3,
  "& .MuiTab-root": {
    textTransform: "none",
    fontWeight: 700,
    color: "var(--gray-400, #9e9e9e)",
    borderBottom: "1px solid #DFE4E8",
    fontSize: "18px",
    lineHeight: "22px",
    pointerEvents: "none",
    paddingBottom: "17px",
  },
  "& .Mui-selected": {
    color: "var(--blue-200) !important",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "var(--blue-200)",
  },
};

export const tabsFillerSx: SxProps<Theme> = {
  flexGrow: 1,
  borderBottom: "1px solid #DFE4E8",
};

export const stepContentSx: SxProps<Theme> = {
  minHeight: 200,
};

export const footerSx: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 2,
  pt: 2,
};

export const backButtonSx: SxProps<Theme> = {
  borderRadius: "12px",
  color: "var(--blue-200)",
  borderColor: "var(--blue-200)",
};

export const nextButtonSx: SxProps<Theme> = {
  borderRadius: "12px",
};

export const closeIconSx: SxProps<Theme> = {
  color: "#001E50",
  fontSize: "32px",
};
